import { AutoCenter, Badge, Button, Dialog, Divider, List, Modal, Space, SwipeAction, Toast } from "antd-mobile";
import React, { useRef } from "react";
import { pubCall } from "../utils/PubSub";
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import duration from 'dayjs/plugin/duration';
import Info from "./Info";
import { drawPrice } from "../utils/utils";

export default function ListItem(props) {


    dayjs.extend(utc);
    dayjs.extend(duration);

    const { item = {}, oh=false, isnew = false, canFade = false, fade = false, selected = false, setSelected = () => { },
        remove = () => { },
        increment = () => { },
        leftActions,
        rightActions,
        noswipe = false,
        search = () => { }
    } = props;

    const swipeActionRef = useRef(null);

    const {
        category_1 = "",
        category_2 = "",
        date = "",
        price = "",
        work_station = "",
        title = "",
        primary_code = "",
        reconciliation_id = "",
        counted = 0,
        onhand = 0,
        condition_code = "Test",
    } = item;

    function drawTime(utcDate) {
        const now = dayjs(); // Local current time
        const inputDate = dayjs.utc(utcDate); // Parse the input as UTC

        const diff = dayjs.duration(now.diff(inputDate));
        const days = Math.floor(diff.asDays());
        const hours = diff.hours();
        const minutes = diff.minutes();


        let result = '';
        if (days > 0) {
            result = `${days}d${days > 1 ? '' : ''} `;
            return result;
        }
        if (hours > 0) {
            result = `${hours}h${hours > 1 ? '' : ''} `;
            return result;
        }
        if (minutes > 0) {
            result = `${minutes}m${minutes > 1 ? '' : ''}`;
            return result;
        }

        return 'now';
    }



    const in_inventory = (item?.stock_data) ? true : false;

    let _style = {
        height: "104px"
    }



    const is_selected = (reconciliation_id === selected?.reconciliation_id);


    _style.backgroundColor = (is_selected) ? "#333" : "#242628";

    if (!is_selected && props?.searching && props?.searching === reconciliation_id) {
        _style.backgroundColor = "#007ef544";
    }



  



    const count_colour = (is_selected) ? "#881798" : (!counted) ? "#222" : (counted - onhand === 0) ? "#34b368" : "#007EF5";
    const diff_colour = (counted - onhand > 0) ? "#a65959" : (counted - onhand === 0) ? "#222" : "#b3b24c";

    const editCount = () => {
        if (selected?.reconciliation_id == item.reconciliation_id) {
            setSelected(false)
        } else {
            setSelected({ ...item, "init": true });
        }

    }

    const showInfo = () => {

        const handler = Modal.show({

            style: { zIndex: "1002" },
            closeOnMaskClick: true,
            bodyStyle: { zIndex: "1002" },
            content: <div onClick={(e) => {
                console.log(e);
                handler.close();
            }}><Info oh={oh} search={(e) => {
                search(e);
                handler.close();
            }} data={item} /></div>,
            confirmText: "Close"
        })

    }


    const searchItem = () => {

        pubCall("title_link.search", { limit: 1, term: primary_code, type: "isbn", scope: "both", sort: "rank" }, (_s, _r) => {
            if (_s) {
                if (_r.rows.length > 0) {
                    Dialog.alert({
                        style: { zIndex: "1002" },
                        bodyStyle: { zIndex: "1002" },
                        content: <><AutoCenter><strong>{primary_code}</strong></AutoCenter><AutoCenter>{_r.rows[0]?.title_link.title}</AutoCenter></>,
                        confirmText: "Close"
                    })
                } else {
                    Dialog.alert({
                        style: { zIndex: "1002" },
                        bodyStyle: { zIndex: "1002" },
                        content: <><AutoCenter><strong>{primary_code}</strong></AutoCenter><AutoCenter>Title not found</AutoCenter></>,
                        confirmText: "Close"
                    })
                }
            } else {
                Dialog.alert({
                    style: { zIndex: "1002" },
                    bodyStyle: { zIndex: "1002" },
                    content: <><AutoCenter><strong>{primary_code}</strong></AutoCenter><AutoCenter>Title not found</AutoCenter></>,
                    confirmText: "Close"
                })
            }
        })
    }

    const handleOpenSwipeAction = () => {
        if (swipeActionRef.current) {
            swipeActionRef.current.show('left'); // Open to the left
        }
    };


    const draw = () => {

        const countLength = (selected?.counted) ? selected.counted.toString().length : 1;

        return (
            <>
                <div onClick={() => showInfo()} key={reconciliation_id}>
                    <List.Item
                        className={(item?.animate) ? "list_added" : ""}
                        style={_style}
                        description={
                            <>
                                <div style={{ "display": "flex", "textAlign": "right" }}>
                                    <div style={{ "width": "19%", "textAlign": "left" }}>
                                        {(noswipe && <span style={{ "color": "#fff", 'backgroundColor': "#881798", "padding": "0px 3px", "borderRadius": "3px" }}><nobr>EDIT MODE</nobr></span>)}
                                    </div>
                                    <div style={{ "width": "40%" }}>

                                        <div style={{ "backgroundColor": (in_inventory) ? "none" : "#e70d3d", "display": "inline", "padding": (in_inventory) ? "0px 0px" : "0px 5px", "borderRadius": "2px", "lineHeight": "18px", "textAlign": "right" }}><span style={{ "color": "#fff", "opacity": "0.9" }}>{primary_code}</span><span style={{ "color": (in_inventory) ? "#48D758" : "#000", "fontWeight": "bold" }}>{condition_code}</span></div>
                                    </div>
                                    <div style={{ "width": "41%", "textAlign": "right" }}>
                                        <Space><small><em>{drawTime(date)}</em></small> <span>#{work_station}</span></Space> &nbsp;&nbsp;&nbsp;
                                    </div>
                                </div>
                                <div className="shim" />
                                <div style={{ "display": "flex", "textAlign": "center" }}>

                                    <div style={{ "width": "16%" }}>
                                        <div onClick={(e) => { e.preventDefault(); e.stopPropagation(); setSelected(item) }}>
                                            <Badge style={{ "padding": "5px" }} color={count_colour} content={<div style={{ "fontSize": "13px", "fontWeight": "bold", "textAlign": "center", "width": "30px" }}>
                                                {(counted && !is_selected) ? counted : (!is_selected) ? <>&nbsp;</> : <>{(!selected?.counted && <>&nbsp;</>)}</>} {(is_selected && <div>{selected?.counted}{(selected?.counted === "" && <>&nbsp;</>)}</div>)}
                                                {((is_selected && selected?.init) && <div className="blink" style={{ "position": "absolute", "bottom": "18px", "width": "30px" }}><div style={{ "width": (countLength) ? (countLength * 8) + "px" : "8px", "height": "2px", "margin": "0 auto", "backgroundColor": "#48D758" }}></div></div>)}
                                            </div>} />
                                        </div>
                                    </div>
                                    <div onClick={(e) => { e.preventDefault(); e.stopPropagation(); setSelected(item) }} style={{ "width": "9%" }}>{onhand}</div>
                                    <div style={{ "width": "16%" }}>
                                        <div onClick={(e) => { e.preventDefault(); e.stopPropagation(); setSelected(item) }} style={{ "textAlign": "center" }}>
                                            <Badge style={{ "padding": "5px" }} color={diff_colour} content={<div style={{ "fontSize": "13px", "fontWeight": "bold", "textAlign": "center", "width": "30px" }}>
                                                {(counted - onhand) ? counted - onhand : <>&nbsp;</>}
                                            </div>} />
                                        </div>
                                    </div>
                                    <div style={{ "width": "18%", "textAlign": "right" }}>
                                        <span style={{ "opacity": "0.9" }}>{drawPrice(price, true)}</span>
                                    </div>
                                    <div style={{ "width": "2%", "textAlign": "right" }}>
                                        <span style={{ "opacity": "0.9" }}></span>
                                    </div>
                                    <div style={{ "width": "30%", "textAlign": "left" }}>
                                        <span style={{ "opacity": "0.9", "color": "#b3b24c" }}><nobr>{category_1}{(category_2) ? "-" + category_2 : ""}</nobr></span>
                                    </div>
                                </div>
                                {/* <div className="float-flex">
                                    <div style={{ "marginTop": "-25px", "marginRight": "6px" }}>
                                        <div className="shim" />
                                        <Space>
                                            <div style={{ "textAlign": "center" }}>
                                                <div style={{ "fontSize": "12px" }}>COUNT{props.searching}</div>
                                                <div className="shim" />
                                                <div onClick={() => setSelected(item)}>
                                                    <Badge style={{ "padding": "5px" }} color={count_colour} content={<div style={{ "fontSize": "13px", "fontWeight": "bold", "textAlign": "center", "width": "30px" }}>
                                                        {(counted && !is_selected) ? counted : (!is_selected) ? <>&nbsp;</> : <>{(!selected?.counted && <>&nbsp;</>)}</>} {(is_selected && <div>{selected?.counted}{(selected?.counted === "" && <>&nbsp;</>)}</div>)}
                                                        {((is_selected && selected?.init) && <div className="blink" style={{ "position": "absolute", "bottom": "18px", "width": "30px" }}><div style={{ "width": (countLength) ? (countLength * 8) + "px" : "8px", "height": "2px", "margin": "0 auto", "backgroundColor": "#48D758" }}></div></div>)}
                                                    </div>} />
                                                </div>
                                            </div>
                                            <div style={{ "textAlign": "center" }}>
                                                <div style={{ "fontSize": "12px" }}>DIFF</div>
                                                <div className="shim" />
                                                <Badge style={{ "padding": "5px" }} color={diff_colour} content={<div style={{ "fontSize": "13px", "fontWeight": "bold", "textAlign": "center", "width": "30px" }}>
                                                    {(counted - onhand) ? counted - onhand : <>&nbsp;</>}
                                                </div>} />
                                            </div>
                                        </Space>
                                    </div>
                                    <div>
                                        <div className="shim" />
                                        <Space>
                                            <div><span style={{ "color": "#fff", "opacity": "0.9" }}>{onhand}</span> ONHAND</div>
                                            <Divider direction="vertical" style={{ "margin": "0px 5px" }} />
                                            <div style={{ "backgroundColor": (in_inventory) ? "none" : "#e70d3d", "padding": "0px 5px", "borderRadius": "2px", "lineHeight": "18px" }}><span style={{ "color": "#fff", "opacity": "0.9" }}>{primary_code}</span><span style={{ "color": (in_inventory) ? "#48D758" : "#000", "fontWeight": "bold" }}>{condition_code}</span></div>
                                            <div>&nbsp;</div>
                                        </Space>
                                    </div>
                                </div> */}
                            </>
                        }
                    >

                        <div style={{ "whiteSpace": "nowrap", "textOverflow": "ellipsis", "overflow": "hidden", "width": "350px", "fontSize": "14px", "marginTop": "-5px" }}>

                            {(noswipe && <>
                                <div>

                                    <big>{((!in_inventory && <span><span style={{ "color": "#e70d3d" }}><em>(Not in Inventory)</em></span></span>))}{title} &nbsp;</big>
                                </div>
                            </>)}

                            {(!noswipe && <>
                                <big>{((!in_inventory && <span><span style={{ "color": "#e70d3d" }}><em>(Not in Inventory)</em></span> <a onClick={() => searchItem()}> Search</a></span>))}{title} &nbsp;</big>
                            </>)}


                        </div>



                    </List.Item>
                    <div style={{ "backgroundColor": "#121212", "height": "2px" }} className="shim" />
                </div>
            </>
        )
    }

    if (noswipe) {
        return draw();
    }

    return (
        <SwipeAction ref={swipeActionRef} closeOnAction={false} key={item.reconciliation_id} onAction={(e) => {

            console.log(e);
            switch (e.key) {
                case "remove":

                    const handler = Modal.show({
                        title: "Remove confirmation",
                        content: <>
                            Are you sure you wish to remove this title?
                            <br />
                            <br />
                            <div className="float-flex">
                                <div>&nbsp;</div>
                                <Space>
                                    <Button onClick={() => handler.close()}>Cancel</Button>
                                    <Button color="danger" onClick={() => {
                                        remove(item)
                                        handler.close();
                                    }}>Remove</Button>
                                </Space>
                            </div>
                        </>
                    })

                    break;
                case "increment":
                    increment(item, 1)
                    break;
                case "decrement":
                    increment(item, -1)
                    break;
                case "number":
                    editCount(item);
                    swipeActionRef.current.close()
                    break;
                case "info":
                    showInfo(item);
                    swipeActionRef.current.close()
                    break;
            }

        }} leftActions={leftActions} rightActions={rightActions}>
            {draw()}
        </SwipeAction>
    )
}